import {
   userStart,
   userFailure,
   loginSuccess,
   loginFailure,
   logoutSuccess,
   updateUserSuccess,
   createUserSuccess,
} from "./userRedux"
import {
   orderStart,
   orderFailure,
   getOrderSuccess,
   createOrderSuccess,
} from "./orderRedux"
import {
   serviceStart,
   serviceFailure,
   getServiceSuccess,
   createServiceSuccess,
} from "./serviceRequestRedux"
import { publicRequest, userRequest } from "../requestMethods"

export const login = async (user, dispatch) => {
   dispatch(userStart())
   try {
      const res = await publicRequest.post("/auth/login", user)
      dispatch(loginSuccess(res.data))
      return "success"
   } catch (err) {
      dispatch(loginFailure(err.response ? err.response.data : err.message))
      return err.response ? err.response.data : err.message
   }
}

export const logout = async (dispatch) => {
   dispatch(userStart())
   try {
      dispatch(logoutSuccess())
   } catch (err) {
      dispatch(loginFailure(err.response.data))
   }
}

export const updateUser = async (
   id,
   user,
   dispatch,
   token,
   updates,
   origin
) => {
   dispatch(userStart())
   try {
      await userRequest.put(
         `/users/${id}`,
         { ...user, origin, updates },
         {
            headers: { Authorization: `Bearer ${token}` },
         }
      )
      dispatch(updateUserSuccess({ id, user }))
      return "success"
   } catch (err) {
      dispatch(userFailure(err.response.data))
      return err.response.data
   }
}

export const register = async (user, dispatch) => {
   dispatch(userStart())
   try {
      await userRequest.post("/auth/register", user)
      dispatch(createUserSuccess({ user }))
      return "success"
   } catch (err) {
      dispatch(userFailure(err.response.data))
      return err.response.data
   }
}

export const createOrder = async (order, dispatch, token) => {
   dispatch(orderStart())
   try {
      await userRequest.post("/orders", order, {
         headers: { Authorization: `Bearer ${token}` },
      })
      dispatch(createOrderSuccess({ order }))
      return "success"
   } catch (err) {
      dispatch(orderFailure(err.response.data))
      return err.response.data
   }
}

export const getOrders = async (userId, dispatch) => {
   dispatch(orderStart())
   try {
      const res = await publicRequest.get(`/orders/find/user/${userId}`)
      dispatch(getOrderSuccess(res.data))
      return "success"
   } catch (err) {
      dispatch(orderFailure(err.response.data))
      return err.response.data
   }
}

export const createServiceRequest = async (request, dispatch, token) => {
   dispatch(serviceStart())
   try {
      await userRequest.post("/service", request, {
         headers: { Authorization: `Bearer ${token}` },
      })
      dispatch(createServiceSuccess({ request }))
      return "success"
   } catch (err) {
      dispatch(serviceFailure(err.response.data))
      return err.response.data
   }
}

export const getServiceRequest = async (userId, dispatch, token) => {
   dispatch(serviceStart())
   try {
      const res = await userRequest.get(`/service/find/user/${userId}`, {
         headers: { Authorization: `Bearer ${token}` },
      })
      dispatch(getServiceSuccess(res.data))
      return "success"
   } catch (err) {
      dispatch(serviceFailure(err.response.data))
      return err.response.data
   }
}
